module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/rain-2-4e03defbb1ef8c4efa3422ce36a6b5a3.svg";